module.exports = __webpack_public_path__ + "static/media/Slice16@2x.8a4084a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice16@2x.png
// module id = 1445
// module chunks = 0